import YomeAPI from 'src/constants/network.constants'
import { sendFormPost } from 'src/utils/network.utils'

// eslint-disable-next-line import/prefer-default-export
export const reportPost = (offerId : string, reason: string, comment: string): Promise<Record<string, string>> => (
  sendFormPost(YomeAPI.reportOffer(offerId), { reason, comment }))
